import { Component, Inject, NgZone } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DeclineReasonEnum } from 'server/shared/models/declineReason.enum';

export interface DialogData {
  additionalWarning?: string;
}

@Component({
  selector: 'decline-invitee-dialog',
  templateUrl: 'decline-invitee-dialog.html',
  styleUrls: ['./decline-invitee-dialog.component.scss'],
})
export class DeclineInviteeDialog {
  reasonEnum = DeclineReasonEnum;
  reason?: DeclineReasonEnum;
  reasonDescription?: string;
  informInviteeOfReason: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<DeclineInviteeDialog>,
    private ngZone: NgZone,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
  ) {}

  close(): void {
    this.dialogRef.close();
  }
}
